import React from 'react';
import './HeaderWordmark.css';

// The official IronSight wordmark for app headers, on a cream plate — the
// ink-on-dark problem and the plate treatment mirror the landing nav.
// Replaces the old icon + styled-text lockup so the app carries the real
// brand artwork (client-supplied file, unmodified).
function HeaderWordmark() {
    return (
        <span className="hdr-wordmark-plate">
            <img src="/ironsight-wordmark.png" alt="IronSight" className="hdr-wordmark-img" />
        </span>
    );
}

export default HeaderWordmark;
